import React from "react";
const Footer = () => {
  return (
    <>
      Created by Arkadiusz Strzelec ------- API key: http://api.lololyrics.com/
    </>
  );
};

export default Footer;
